import actions from './actions';
import mutations from './mutations';

const data = {
    namespaced: true,
    state: {
        operator: null
    },
    mutations,
    actions
};

export default data;
